//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BussinessProcessButton from './BussinessProcessButton.vue'

export default {
  components: {
    BussinessProcessButton
  },
  props: {
    record: {
      type: Object,
      default: () => {
        return {}
      }
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      showFab: false
    }
  },
  computed: {
    actions: function () {
      return this.record.actions.filter(action => action.id !== 'save' && action.id !== 'copy')
    },
    actionsWithoutGroup: function () {
      return this.actions.filter(action => !action.operationGroup)
    },
    operationGroups: function () {
      const operationGroups = []
      const actionsWithGroup = this.actions.filter(action => !!action.operationGroup)
      actionsWithGroup.forEach(action => {
        const operationGroup = operationGroups.find(operationGroup => operationGroup.id === action.operationGroup.id)
        if (operationGroup != null) {
          operationGroup.actions.push(action)
        } else {
          operationGroups.push({
            actions: [action],
            ...action.operationGroup
          })
        }
      })
      return operationGroups
    }
  },
  methods: {
    onUpdate: function (id) {
      this.$emit('update', id)
    },
    onValidate: function (validFieldKeys) {
      this.$emit('validate', validFieldKeys)
    }
  }
}

